// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"0d6c356b","88":"9c5ecfca","174":"860aea0a","216":"841de779","272":"00a834d7","281":"4f5f2d60","310":"248dc84a","432":"32fee645","488":"ccc9b638","627":"43459bcf","675":"aa0e5900","990":"7646b88d"}[chunkId] + ".chunk.js";
};